import { useEffect, useState } from "react";

interface SelectOptionSingleButtonProps {
  datas: string[] | undefined;
  value: string;
  onValueChange: (value: string) => void;
}

export default function SelectOptionSingleButton({
  datas,
  value,
  onValueChange,
}: SelectOptionSingleButtonProps) {
  const [selected, setSelected] = useState<string>("");

  useEffect(() => {
    setSelected(value);
  }, [value]);

  return (
    <div className="flex flex-wrap gap-2">
      {datas?.map((item) => (
        <button
          key={item}
          onClick={() => {
            setSelected(item);
            onValueChange(item);
          }}
          className={`border px-4 py-1.5 rounded-lg text-sm font-semibold ${
            selected === item ? "bg-primary text-white" : "border-gray-300" // Apply active style
          }`}
        >
          {item}
        </button>
      ))}
    </div>
  );
}
